import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
  TitleStrategy,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from '@angular/router';
import { TitlesService } from '../services/titles.service';

@Injectable()
export class CustomTitleStrategy extends TitleStrategy {
  private titlesService = inject(TitlesService);
  constructor(private readonly titleService: Title) {
    super();
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const title = this.buildTitle(snapshot);
    if (title) {
      this.titleService.setTitle(title);
    }
  }

  override buildTitle(snapshot: RouterStateSnapshot): string {
    const titles = [];
    if (!this.checkForTitleOverride(snapshot.root)) {
      this.titlesService.clearCachedTitles();
    }
    this.buildTitlesArray(snapshot.root, titles);
    return titles.join(' | ');
  }

  private buildTitlesArray(snapshot: ActivatedRouteSnapshot, titles: string[]) {
    if (snapshot.routeConfig?.title || snapshot.routeConfig?.path) {
      if (snapshot.data.overridePreviousTitle) {
        titles.length = 0;
      }

      let title =
        snapshot.data.title ||
        snapshot.routeConfig?.title ||
        this.transformPathToTitle(snapshot.routeConfig?.path);

      title = this.titlesService.changeTitleFromCache(title);

      titles.push(title);
    }

    if (snapshot.firstChild) {
      this.buildTitlesArray(snapshot.firstChild, titles);
    }
  }

  private checkForTitleOverride(snapshot: ActivatedRouteSnapshot): boolean {
    if (snapshot.data.overridePreviousTitle) {
      return true;
    }

    return snapshot.firstChild
      ? this.checkForTitleOverride(snapshot.firstChild)
      : false;
  }

  private transformPathToTitle(path: string): string {
    if (!path) return '';
    const formatted = path.replace(/\//g, ' | ').replace(/-/g, ' ');

    return formatted
      .split(' | ')
      .map((part) => {
        const trimmed = part.trim();
        return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
      })
      .join(' | ');
  }
}
